import {getQueryClient} from './client'

export const getReaderQueryClient = () => getQueryClient({context: false})
